"use client";
import {
  PhoneIcon,
  MailIcon,
  LinkedInIcon,
  GithubIcon,
} from "./Icons";

import Avatar2 from "../assets/Avatar2.png";
import Avatar4 from "../assets/Avatar6.png";
import Avatar5 from "../assets/Avatar5.png";
import { useState } from "react";
import axios from "axios";
import { jobsEndpoint } from "../constants"; // ✅ SAME constant as ApplicantDetails
import Comments from "../pages/Comment";
import { useNavigate } from "react-router-dom";

export const ProfileHeader = ({ candidate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const candidateData = candidate
    ? {
        id: candidate.id,
        name: candidate.user
          ? `${candidate.user.first_name} ${candidate.user.last_name}`
          : "Unknown User",
        email: candidate.user?.email || "No email provided",
        avatar:
          candidate.user?.avatar ||
          "https://cdn.builder.io/api/v1/image/assets/TEMP/331f5bfe652647f1cdaed51ce64ed5368141bb2b",
        job: candidate.job || "Not specified",
        cv: candidate.cv || [], // ✅ expecting an array of files (like ApplicantDetails)
        cover_letter: candidate.cover_letter || [],
        application: candidate.application || "No application text",
        ai_review: candidate.ai_review || "No AI review yet",
        ai_score: candidate.ai_score ?? "N/A",
        ai_rating: candidate.ai_rating || "N/A",
        ai_criticism: candidate.ai_criticism || "N/A",
        ai_recommendation: candidate.ai_recommendation || "N/A",
        ai_advantages: candidate.ai_advantages || "N/A",
        date_published: candidate.date_published
          ? new Date(candidate.date_published).toLocaleDateString()
          : "N/A",
        date_updated: candidate.date_updated
          ? new Date(candidate.date_updated).toLocaleDateString()
          : "N/A",
      }
    : {
        id: 0,
        name: "Oliver Rey",
        email: "oliverrayyyy@example.com",
        avatar:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/331f5bfe652647f1cdaed51ce64ed5368141bb2b",
        job: "Software Engineer",
        cv: [],
        cover_letter: [],
        application: "Sample application text",
        ai_review: "Strong candidate",
        ai_score: "N/A",
        ai_rating: "N/A",
        ai_criticism: "N/A",
        ai_recommendation: "N/A",
        ai_advantages: "N/A",
        date_published: "N/A",
        date_updated: "N/A",
      };
// ✅ SAME download method as ApplicantDetails with dynamic file extension
const downloadFile = async (fileId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${jobsEndpoint}files/${fileId}/download/`, {
      headers: { Authorization: `Token ${token}` },
      responseType: "blob",
    });
    console.log(response.data)
    // Extract filename with extension from Content-Disposition header
    let filename = `file_${fileId}`; // fallback filename
    const contentDisposition = response.headers['content-disposition'];
    
    if (contentDisposition) {
      // Parse Content-Disposition header to extract filename
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        // Remove quotes if present
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    // If filename from header doesn't have extension, try to get it from content-type
    if (!filename.includes('.')) {
      const contentType = response.headers['content-type'];
      const extension = getExtensionFromMimeType(contentType);
      if (extension) {
        filename = `${filename}.${extension}`;
      }
    }

    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", candidate.cv[0].file_name);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
    
    console.log(`Downloaded file: ${filename}`);
  } catch (error) {
    console.error("Error downloading file:", error);
    alert(`Failed to download file`);
  }
};

// Helper function to get file extension from MIME type
const getExtensionFromMimeType = (mimeType) => {
  const mimeToExtension = {
    'application/pdf': 'pdf',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'text/plain': 'txt',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'application/zip': 'zip',
    'text/csv': 'csv',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    // Add more mime types as needed
  };
  
  return mimeToExtension[mimeType] || null;
};

// Alternative approach: If you want to fetch file info first
const downloadFileWithInfo = async (fileId, fallbackFilename = "cv") => {
  try {
    const token = localStorage.getItem("token");
    
    // First, get file info (you'd need to create this endpoint or modify existing one)
    const infoResponse = await axios.get(`${jobsEndpoint}files/${fileId}/`, {
      headers: { Authorization: `Token ${token}` }
    });
    
    // Use the file_name from the response if available
    const filename = infoResponse.data.file_name || fallbackFilename;
    
    // Then download the file
    const response = await axios.get(`${jobsEndpoint}files/${fileId}/download/`, {
      headers: { Authorization: `Token ${token}` },
      responseType: "blob",
    });

    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
    
    console.log(`Downloaded file: ${filename}`);
  } catch (error) {
    console.error("Error downloading file:", error);
    alert(`Failed to download file`);
  }
};


  return (
    <section className="flex flex-col gap-8 px-8 relative">
      {/* === Header === */}
      <div className="flex gap-5 items-start max-md:flex-col relative">
        <div className="flex flex-1 gap-3 items-center max-md:flex-col max-md:items-start">
          <img
            src={candidateData.avatar}
            alt="Profile"
            className="w-[96px] h-[96px] rounded-full object-cover"
          />
          <div className="flex flex-col gap-2 w-96 max-md:w-full">
            <h1 className="text-2xl font-semibold leading-9 text-gray-900">
              {candidateData.name}
            </h1>
            <p className="text-sm text-gray-500">
              Applying for:{" "}
              <span className="font-medium">{candidateData.job}</span>
            </p>
            <div className="flex flex-wrap gap-4 items-center">
              <div className="flex gap-1 items-center">
                <PhoneIcon />
                <p className="text-sm leading-5 text-gray-600">
                  (+1) 469 53 22 382
                </p>
              </div>
              <div className="flex gap-1 items-center">
                <MailIcon />
                <p className="text-sm leading-5 text-gray-600">
                  {candidateData.email}
                </p>
              </div>
            </div>
            <div className="flex gap-1 items-center">
              <LinkedInIcon />
              <GithubIcon />
            </div>
          </div>
        </div>

        {/* Comments */}
        <div className="flex flex-col gap-5 items-end max-md:w-full">
          <button className="flex cursor-pointer gap-1 justify-center items-center px-3.5 py-2.5 bg-teal-500 rounded-lg" onClick={() => navigate(`/candidate/editprofile/${candidateData.id}`)}>
            <span className="text-sm font-semibold leading-5 text-white">
              edit profile
            </span>
          </button>
          <div className="flex gap-3 items-center">
            <div className="pt-3 gap-10 flex items-center justify-between">
              <div className="relative">
                <img src={Avatar4} alt="" className="w-7 h-7" />
                <img
                  src={Avatar5}
                  alt=""
                  className="absolute w-7 h-7 z-40 left-[14px] top-0"
                />
                <img
                  src={Avatar2}
                  alt=""
                  className="absolute w-7 h-7 z-40 left-[32px] top-0"
                />
              </div>
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
              >
                <p className="text-[#009C97] text-xs font-normal">
                  <span>3</span> comments
                </p>
              </div>
            </div>
          </div>
        </div>

        {isOpen && (
          <div className="absolute right-0 z-[42] bg-white">
            <Comments open={setIsOpen} />
          </div>
        )}
      </div>

      {/* === Applicant Details === */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-gray-50 rounded-xl shadow-sm">
        <Detail label="Application" value={candidateData.application} />

        {/* ✅ CV downloads via same endpoint */}
        {candidateData.cv.length > 0 && (
          <Detail
            label="CV"
            value={
              <div className="flex flex-col gap-1">
                {candidateData.cv.map((file, idx) => (
                  <button
                    key={file.id || idx}
                    onClick={() => downloadFile(file.id)}
                    className="text-blue-600 underline hover:text-blue-800 text-left"
                  >
                    {"Download CV"}
                  </button>
                ))}
              </div>
            }
          />
        )}

        {/* ✅ Cover Letter downloads via same endpoint */}
        {candidateData.cover_letter.length > 0 && (
          <Detail
            label="Cover Letter"
            value={
              <div className="flex flex-col gap-1">
                {candidateData.cover_letter.map((file, idx) => (
                  <button
                    key={file.id || idx}
                    onClick={() =>
                      downloadFile(file.id || `Cover_Letter_${idx + 1}.pdf`)
                    }
                    className="text-blue-600 underline hover:text-blue-800 text-left"
                  >
                    {file.name || `Cover_Letter_${idx + 1}.pdf`}
                  </button>
                ))}
              </div>
            }
          />
        )}

        <Detail label="AI Review" value={candidateData.ai_review} />
        <Detail label="AI Score" value={candidateData.ai_score} />
        <Detail label="AI Rating" value={candidateData.ai_rating} />
        <Detail label="AI Criticism" value={candidateData.ai_criticism} />
        <Detail label="AI Recommendation" value={candidateData.ai_recommendation} />
        <Detail label="AI Advantages" value={candidateData.ai_advantages} />
        <Detail label="Date Published" value={candidateData.date_published} />
        <Detail label="Date Updated" value={candidateData.date_updated} />
      </div>
    </section>
  );
};

const Detail = ({ label, value }) => (
  <div className="flex flex-col">
    <span className="text-sm text-gray-500">{label}</span>
    <span className="text-base text-gray-800 break-words">{value}</span>
  </div>
);
